<div>
  <div #dropZone class="add__dropzone" ttFileDrop [allowedTypes]="allowedTypes" (fileDrop)="onFileChange($event)">
    <div>
      <div class="add__dropzone__status">
        <mat-icon [class]="file ? 'icon-check' : 'icon-upload'" [icon]="file ? 'circle-check' : 'upload'" [iconSize]="24" />
      </div>
      <input #fileInput accept=".ris, .bib" id="file" name="file" type="file" (change)="onFileChange($event.target.files[0])" />

      @if (!file) {
        <div class="add__dropzone__select">
          <span class="add__dropzone__info">{{ 'DragAndDropLiteratureFiles' | transloco }} </span>
          @if (!file) {
            <label class="add__dropzone__action" for="file">{{ 'Select' | transloco }}</label>
          }
        </div>
      }

      @if (file) {
        <div class="add__dropzone__change">
          <p class="add__dropzone__info">{{ 'FileUploadSuccessful' | transloco }}</p>
          <label class="add__dropzone__action" for="file">{{ 'ChangeFile' | transloco }}</label>
          <span class="add__dropzone__action" (click)="delete()">{{ 'Delete' | transloco }}</span>
        </div>
      }
    </div>
  </div>
</div>
